import { Link } from "react-router-dom";
import { Github, Linkedin, Twitter, Instagram, Mail, ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/10 bg-[#050505]"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Link to="/" data-testid="footer-logo" className="inline-flex items-center gap-2.5">
              <span className="w-9 h-9 grid place-items-center rounded-lg bg-gradient-to-br from-blue-500 to-blue-700 shadow-[0_0_24px_-4px_rgba(59,130,246,0.7)]">
                <span className="font-display font-bold text-white">C</span>
              </span>
              <span className="font-display text-xl text-white">
                Coding<span className="text-blue-400">Solutions</span>
              </span>
            </Link>
            <p className="mt-6 max-w-md text-zinc-400 leading-relaxed">
              We design and develop high-performance websites, Shopify stores,
              WordPress solutions, and custom web applications that grow
              businesses worldwide.
            </p>
            <a
              data-testid="footer-email-link"
              href="mailto:info@codingsolutions.in"
              className="mt-6 inline-flex items-center gap-2 text-white hover:text-blue-400 transition-colors"
            >
              <Mail size={16} /> info@codingsolutions.in
            </a>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-5">
              Company
            </h4>
            <ul className="space-y-3 text-zinc-300">
              <li><Link to="/about" data-testid="footer-about-link" className="hover:text-white">About</Link></li>
              <li><Link to="/services" data-testid="footer-services-link" className="hover:text-white">Services</Link></li>
              <li><Link to="/portfolio" data-testid="footer-portfolio-link" className="hover:text-white">Portfolio</Link></li>
              <li><Link to="/contact" data-testid="footer-contact-link" className="hover:text-white">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-5">
              Services
            </h4>
            <ul className="space-y-3 text-zinc-300">
              <li>Shopify Development</li>
              <li>WordPress Development</li>
              <li>Custom Web Apps</li>
              <li>UI/UX Design</li>
              <li>Maintenance</li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-5">
              Let&apos;s Talk
            </h4>
            <Link
              to="/contact"
              data-testid="footer-cta-button"
              className="inline-flex items-center gap-2 rounded-full border border-white/15 hover:border-white/40 text-white px-5 py-3 text-sm transition-colors"
            >
              Start Your Project <ArrowUpRight size={16} />
            </Link>
            <div className="mt-6 flex items-center gap-3">
              {[
                { Icon: Twitter, href: "#", id: "twitter" },
                { Icon: Linkedin, href: "#", id: "linkedin" },
                { Icon: Instagram, href: "#", id: "instagram" },
                { Icon: Github, href: "#", id: "github" },
              ].map(({ Icon, href, id }) => (
                <a
                  key={id}
                  href={href}
                  data-testid={`footer-social-${id}`}
                  aria-label={id}
                  className="w-10 h-10 grid place-items-center rounded-full border border-white/10 text-zinc-300 hover:text-white hover:border-white/40 transition-colors"
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <p className="text-sm text-zinc-500">
            © 2026 Coding Solutions. All Rights Reserved.
          </p>
          <p className="text-sm text-zinc-500">
            codingsolutions.in — Crafted with intention.
          </p>
        </div>
      </div>
    </footer>
  );
}
